import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { PublicationModal } from "./PublicationModal";
import { useDeleteUserProfileSectionItem } from "Constant/apiHooks";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";
import { toast } from "react-toastify";

export const Publications = ({
  publicationList,
  fetchData,
  isCurrentUserProfile,
}) => {
  const { t } = useTranslation();

  const { deleteUserProfileSectionItem } = useDeleteUserProfileSectionItem();

  const [publicationModal, setShowPublicationModal] = useState(false);
  const [selectedPublication, setSelectedPublication] = useState(null);

  const togglePublicationModal = (pblicatn) => {
    setShowPublicationModal((prev) => !prev);
    if (pblicatn) {
      setSelectedPublication(pblicatn);
    } else {
      setSelectedPublication(null);
    }
  };

  const convertBooleanToString = (val) => {
    if (val === true) {
      return t("common.button.yes");
    }
    if (val === false) {
      return t("common.button.no");
    }
    return "";
  };

  const handleDeletePublication = async (gid) => {
    try {
      const payload = {
        key: VIEW_PROFILE_SECTIONS.publication,
        [VIEW_PROFILE_SECTIONS.publication]: {
          gid,
        },
      };
      await deleteUserProfileSectionItem(payload);
      fetchData();
    } catch {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
        <div className="d-flex justify-content-between align-items-center gap-3">
          <h4 className="mb-0 text-md font-semibold text-grey-800">Publications</h4>
          {isCurrentUserProfile && (
            <div className="d-flex align-items-center gap-1">
              <button
                type="button"
                className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1"
                onClick={() => togglePublicationModal()}
              >
                <i className="bx bx-plus"></i>{" "}
                {t("auth.viewProfile.addPublication")}
              </button>
            </div>
          )}
        </div>

        <ul className="exp-highlight-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-1">
          {publicationList && publicationList.length > 0 ? (
            publicationList.map((pblicatn, idx) => (
              <li
                key={idx.toString()}
                className="d-flex flex-column gap-3 py-4"
              >
                <div className="d-flex justify-content-between align-items-start gap-3">
                  <div className="d-flex flex-column gap-1 w-100">
                    <div className="d-flex gap-3">
                      <h5 className="mb-0 text-base font-semibold text-grey-800">
                        {pblicatn.title}
                      </h5>
                      {isCurrentUserProfile && (
                        <div className="ms-auto d-flex align-items-center gap-3">
                          <Button
                            variant="link"
                            className="p-0 text-base text-grey-600 text-decoration-none"
                            onClick={() => togglePublicationModal(pblicatn)}
                          >
                            <i className="bx bx-pencil"></i>
                          </Button>
                          <Button
                            variant="link"
                            className="p-0 text-base text-grey-600 text-decoration-none"
                            onClick={() =>
                              handleDeletePublication(pblicatn.gid)
                            }
                          >
                            <i className="bx bx-trash"></i>
                          </Button>
                        </div>
                      )}
                    </div>
                    <span>
                      {t("common.label.publisherName")}:{" "}
                      {pblicatn.publisherName}
                    </span>
                    <span>
                      {pblicatn.type === "Other"
                        ? pblicatn.otherPublicationType
                        : pblicatn.type}
                      , {pblicatn.yearOfPublication} -{" "}
                      <span className="font-bold text-primary-800">
                        <a href={pblicatn.doiOrUlr} target="_blank">
                          {pblicatn.doiOrUlr}
                        </a>
                      </span>
                    </span>
                    <span>
                      {t("common.label.isFirstAuthor")}{" "}
                      {convertBooleanToString(pblicatn.firstAuthor)}
                    </span>
                    <span>
                      {t("common.label.authors")}:{" "}
                      {pblicatn.authors && pblicatn.authors.length > 0
                        ? pblicatn.authors.join(", ")
                        : ""}
                    </span>
                    <span>
                      {t("common.label.keywordsOrResearchTopics")}:{" "}
                      {pblicatn.keywordsOrResearcTopics}
                    </span>
                    <span>
                      {t("common.label.abstract")}: {pblicatn.abstractDtls}
                    </span>
                  </div>
                  <button
                    type="button"
                    className="mt-1 bg-transparent border-0 w-4 h-4 p-0 d-flex justify-content-center align-items-center"
                  >
                    <img
                      src="/assets/images/icons/arrow-square-out.svg"
                      alt="Arrow Square Out"
                      className="w-100 h-100"
                    />
                  </button>
                </div>
                {pblicatn.uploadPdf && (
                  <ul className="resume-uploaded-list list-unstyled mb-0 d-flex flex-column justify-content-center row-gap-2">
                    <li className="p-3 rounded-lg border border-primary-200 bg-primary-50 d-flex justify-content-between align-items-center gap-3 text-decoration-none">
                      <div>
                        <h5 className="mb-0 text-sm font-semibold text-primary-800">
                          {pblicatn.uploadPdf.name}
                        </h5>
                        <span className="text-xs font-medium text-grey-500">
                          Uploaded on March 2025
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-1">
                        <a
                          href={pblicatn.uploadPdf.url}
                          target="_blank"
                          className="border-0 bg-transparent text-base text-primary-600 w-8 h-8 d-flex justify-content-center align-items-center text-decoration-none"
                        >
                          <i className="bx bx-show-alt"></i>
                        </a>
                      </div>
                    </li>
                  </ul>
                )}
              </li>
            ))
          ) : (
            <li>
              <div className="">
                <span className="text-grey-400">
                  {t("auth.viewProfile.noPublication")}
                </span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {publicationModal && (
        <PublicationModal
          show={publicationModal}
          publicationData={selectedPublication}
          toggle={togglePublicationModal}
          fetchData={fetchData}
        />
      )}
    </>
  );
};
